export default {
  root: {
    cursor: 'pointer'
  }
};
